import moment from "moment";
import { message } from "antd";
import { assistant } from "../../../utils/axios/assistant";

export async function getTemplateMessages() {
  try {
    const res = await assistant.get(`/templates`);
    return res.data;
  } catch (error) {
    console.error("getTemplateMessages > ", error);
    return [];
  }
}

export function getSelectedMessage(message_id, messages, employee) {
  // const { filteredTemplates, employee } = this.state;
  const selectedMessage = messages.find((message) => message.id === message_id);
  const regex = /{{(.*?)}}/g;
  let match;
  const variables = {};
  while ((match = regex.exec(selectedMessage.message)) !== null) {
    variables[match[1].trim()] =
      match[1].trim() === "nombre_operador" ? employee : "";
  }

  const newRenderMessage = selectedMessage.message.replace(
    /{{(.*?)}}/g,
    (value, key) => {
      return key.trim() in variables && variables[key.trim()].length > 0
        ? variables[key.trim()]
        : value;
    }
  );

  return {
    selectedMessage,
    variables,
    renderedMessage: newRenderMessage,
  };
}

export function dateFormatter(timestamp) {
  if (typeof timestamp === "string") timestamp = parseInt(timestamp);
  const isMilliseconds = timestamp.toString().length > 10;
  const date = isMilliseconds ? moment(timestamp) : moment.unix(timestamp);
  const today = moment();
  const yesterday = moment().subtract(1, "days");

  if (date.isSame(today, "day")) {
    return `hoy a las ${date.format("HH:mm")}`;
  } else if (date.isSame(yesterday, "day")) {
    return `ayer a las ${date.format("HH:mm")}`;
  } else {
    return `${date.format("ddd [a las] HH:mm")}`;
  }
}

export async function getChatsId(customerPhones) {
  try {
    const res = await assistant.post(`/get-chats`, {
      phones: customerPhones,
    });
    return res.data.data;
  } catch (error) {
    return {};
  }
}

// TOMAS > Send WhatsApp message
export async function handleSendWhatsApp(
  sendWhatsAppForm,
  sendWhatsAppData,
  employee_id
) {
  try {
    const body = Object.keys(sendWhatsAppData.variables).map((vari) => ({
      type: "text",
      parameter_name: vari,
      text: sendWhatsAppData.variables[vari],
    }));

    const data = { body, buttons: undefined };

    const res = await assistant.post(`/send-message`, {
      client_phone: "+34" + sendWhatsAppForm.phoneNumber.value,
      employee_id,
      message: {
        type: "template",
        template_key: sendWhatsAppData.selectedMessage.meta_name,
        data,
        fullMessage: sendWhatsAppData.renderedMessage,
      },
    });
    message.success("Mensaje enviado exitosamente.");
    return res.data.client_id;
  } catch (error) {
    message.error("Ha ocurrido un error al enviar el mensaje.");
  }
}



// WEBPACK FOOTER //
// ./src/views/Customers/utils/whatsapp.js